// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pc-container[data-v-398530ba]{background:linear-gradient(1turn,#5e2d91,#c63d96)}.pc-visa-logo[data-v-398530ba]{height:16px;width:46px;-o-object-fit:contain;object-fit:contain}@media (min-width:1024px){.pc-visa-logo[data-v-398530ba]{height:18.5px;width:56px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
